var _rect, _g, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 73,
    viewBox: "0 0 77 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.143616,
    width: 72.6257,
    height: 72.6257,
    rx: 8,
    fill: "#FFF1F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_68_1201)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.1539,
    y: 11.9509,
    width: 20.2256,
    height: 20.2256,
    rx: 10.1128,
    fill: "#FECBD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2346 24.6446C53.2346 23.6493 53.3238 22.9334 53.5023 22.497C53.6802 22.0611 54.0579 21.585 54.6354 21.069C55.1392 20.6266 55.523 20.2426 55.7869 19.9167C56.0514 19.5913 56.1836 19.2198 56.1836 18.802C56.1836 18.2982 56.0147 17.8805 55.6771 17.5487C55.3389 17.217 54.8688 17.0511 54.2668 17.0511C53.6401 17.0511 53.1639 17.2415 52.838 17.6224C52.5126 18.0033 52.2824 18.3904 52.1472 18.7836L50.2488 17.9726C50.5069 17.1862 50.9799 16.5043 51.668 15.9268C52.3561 15.3493 53.2223 15.0605 54.2668 15.0605C55.5569 15.0605 56.5492 15.4201 57.2437 16.1391C57.9377 16.8577 58.2847 17.7207 58.2847 18.7283C58.2847 19.3426 58.1527 19.868 57.8888 20.3045C57.6244 20.7404 57.2095 21.2349 56.6443 21.7878C56.0423 22.3653 55.6768 22.8044 55.5481 23.1052C55.4188 23.4065 55.3542 23.9196 55.3542 24.6446H53.2346ZM54.2668 29.068C53.8613 29.068 53.5143 28.9237 53.2258 28.6352C52.9368 28.3462 52.7923 27.999 52.7923 27.5935C52.7923 27.188 52.9368 26.8408 53.2258 26.5518C53.5143 26.2633 53.8613 26.119 54.2668 26.119C54.6722 26.119 55.0195 26.2633 55.3085 26.5518C55.597 26.8408 55.7412 27.188 55.7412 27.5935C55.7412 27.999 55.597 28.3462 55.3085 28.6352C55.0195 28.9237 54.6722 29.068 54.2668 29.068Z",
    fill: "#E21E58"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3011,
    y: 35.1116,
    width: 22.4528,
    height: 21.4831,
    fill: "#E31B56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.487 53.5728H34.7786V50.3466H23.487V53.5728ZM23.487 47.1204H39.6179V43.8942H23.487V47.1204ZM23.487 40.668H39.6179V37.4419H23.487V40.668ZM20.2608 60.0251C19.3736 60.0251 18.6138 59.7095 17.9815 59.0783C17.3502 58.4459 17.0346 57.6862 17.0346 56.799V34.2157C17.0346 33.3285 17.3502 32.5687 17.9815 31.9364C18.6138 31.3051 19.3736 30.9895 20.2608 30.9895H42.8441C43.7313 30.9895 44.491 31.3051 45.1234 31.9364C45.7546 32.5687 46.0703 33.3285 46.0703 34.2157V56.799C46.0703 57.6862 45.7546 58.4459 45.1234 59.0783C44.491 59.7095 43.7313 60.0251 42.8441 60.0251H20.2608Z",
    fill: "#FF99B0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_68_1201",
    x: 32.1539,
    y: 11.9509,
    width: 44.2256,
    height: 44.2256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_68_1201"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_1201"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_68_1201"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_68_1201",
    result: "effect2_dropShadow_68_1201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_68_1201",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhat);
export default __webpack_public_path__ + "static/media/what.4d2d6cf9634e9953f94ae8b84be32a9d.svg";
export { ForwardRef as ReactComponent };